// extracted by mini-css-extract-plugin
export var badge = "_ho-2";
export var detailsPanel = "_ho-0";
export var resultRow = "_ho-1";